import script from "./SeminarPeriodHistory.vue?vue&type=script&setup=true&lang=js"
export * from "./SeminarPeriodHistory.vue?vue&type=script&setup=true&lang=js"

import "./SeminarPeriodHistory.vue?vue&type=style&index=0&id=53155853&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53155853"]])

export default __exports__